import { Feather } from "@expo/vector-icons";
import { useNavigation } from "@react-navigation/native";
import React from "react";
import { useCallback } from "react";
import { useTheme } from "@towersystems/roam-common-native";
import { SellScreenProps } from "../../../../screens/SellScreen";
import { useSaleControllerProvider } from "../../../../utils/sale-controller";
import { QuickKey as BaseQuickKey, QuickKeyProps } from "../../../QuickKey";

export type ParkSaleQuickKeyProps = QuickKeyProps & {};

export const ParkSaleQuickKey = React.forwardRef<any, QuickKeyProps>(
  ({ disabled: _disabled, ..._props }, ref) => {
    const { sale } = useSaleControllerProvider();
    const { colors: Colors } = useTheme();
    const navigation = useNavigation<SellScreenProps["navigation"]>();

    const disabled = _disabled ?? !sale;

    const onPress = useCallback(() => {
      if (disabled) return;
      navigation.navigate("ActionsRootScreen", {
        screen: "ParkScreen",
      });
    }, [disabled]);

    const label = sale ? `Park ${sale.saleType}` : "Park Sale";

    return (
      <BaseQuickKey
        disabled={disabled}
        label={label}
        onPress={onPress}
        ref={ref}
        iconPrimary={<Feather name="pause" size={24} color={Colors.white} />}
        backgroundColor={Colors.action}
        isDestructive={false}
        isAction={true}
        {..._props}
      />
    );
  }
);
